<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="periodoDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-select 
              v-model="filtro.periodoDesdeMesNombre" 
              :options="meses" 
              class="mb-3 select-fecha select-fecha-mes">
              <template slot="first">
                <option :value="null">Seleccione un mes</option>
              </template>
            </b-form-select>
            <b-form-select 
              v-model="filtro.periodoDesdeAnio" 
              :options="anios" 
              class="mb-3 select-fecha select-fecha-anio">
              <template slot="first">
                <option :value="0">Seleccione un año</option>
              </template>
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="periodoHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-select 
              v-model="filtro.periodoHastaMesNombre" 
              :options="meses" 
              class="mb-3 select-fecha select-fecha-mes">
              <template slot="first">
                <option :value="null">Seleccione un mes</option>
              </template>
            </b-form-select>
            <b-form-select 
              v-model="filtro.periodoHastaAnio" 
              :options="anios" 
              class="mb-3 select-fecha select-fecha-anio">
              <template slot="first">
                <option :value="0">Seleccione un año</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <!-- <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button> -->
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { getMesNumero, getMesNumeroToString, getMeses, getAnios, getMesNombre } from '../../mixins/helpers';
import moment from 'moment';

export default {
  components: {
  },
  props: {
    periodoDesde: {
      type: String,
      default: ''
    },
    periodoHasta: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      filtro: {
        periodoDesde: '',
        periodoDesdeDia: 1,
        periodoDesdeMes: 0,
        periodoDesdeMesNombre: null,
        periodoDesdeAnio: 0,

        periodoHasta: '',
        periodoHastaDia: 1,
        periodoHastaMes: 0,
        periodoHastaMesNombre: null,
        periodoHastaAnio: 0,
      },
      showOpcionesFiltro: Boolean(false),
      meses: [],
      anios: [],
      labelCols: 2,
    }
  },
  created() {
    this.meses = this.getMeses();
    this.anios = this.getAnios();

    this.filtro.periodoDesde = moment.utc(this.periodoDesde).format('YYYY-MM-DD');
    this.filtro.periodoHasta = moment.utc(this.periodoHasta).format('YYYY-MM-DD');

    this.filtro.periodoDesdeMes= moment(this.filtro.periodoDesde).month() + 1;
    this.filtro.periodoDesdeMesNombre= this.getMesNombre(this.filtro.periodoDesdeMes);
    this.filtro.periodoDesdeAnio= moment(this.filtro.periodoDesde).year();

    this.filtro.periodoHastaMes= moment(this.filtro.periodoHasta).month() + 1;
    this.filtro.periodoHastaMesNombre= this.getMesNombre(this.filtro.periodoHastaMes);
    this.filtro.periodoHastaAnio= moment(this.filtro.periodoHasta).year();
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.filtro.periodoDesde = parseInt(this.filtro.periodoDesdeAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.filtro.periodoDesdeMesNombre).toString().trim()
          + '-01';

      this.filtro.periodoHasta = parseInt(this.filtro.periodoHastaAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.filtro.periodoHastaMesNombre).toString().trim()
          + '-01';

      this.$emit('filtrar', this.filtro);
    },
  },
}
</script>

<style>
</style>
